import { z } from "zod";

export interface PaginatedRequest {
  limit: number;
  next: string | null;
}

export interface PaginatedResponse<T> {
  total: number;
  items: T[];
  next: string | null;
}

export const PaginatedResponseSchema = z.object({
  next: z.string().nullable(),
  total: z.number(),
});

export const createPaginatedResponseSchema = <T extends z.ZodTypeAny>(
  itemSchema: T,
): z.ZodType<PaginatedResponse<z.infer<T>>> => {
  return z.object({
    next: z.string().nullable(),
    items: z.array(itemSchema),
    total: z.number(),
  });
};
